/* eslint-disable react/jsx-no-useless-fragment */
import {
  HOME,
  SIGNIN,
  ADMIN_DASHBOARD,
  ADMIN_PRODUCTS,
  ADMIN_USERS,
  ADMIN_BRANDS,
  ADMIN_ADS,
  ADMIN_IMAGES,
  ADMIN_PLANS,
  ADMIN_COMPANIES,
  ADMIN_PAYMENTS
} from 'constants/routes';
import PropType from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserNav from 'views/account/components/UserAvatar';
import logo from 'images/logo-full.png';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const MobileAdminNavigation = (props) => {
  const { t } = useTranslation();
  const { isAuthenticating, user } = props;
  const { pathname } = useLocation();

  const onClickLink = (e) => {
    if (isAuthenticating) e.preventDefault();
  };

  return (
    <nav className="mobile-navigation">
      <div className="mobile-navigation-main">
        <div className="mobile-navigation-logo">
          <Link onClick={onClickLink} to={HOME}>
            <img
              alt="Uilpi"
              src={logo}
              style={{ width: '100px', paddingTop: '9px' }}
            />
          </Link>
        </div>

        <ul className="mobile-navigation-menu">
          <LanguageSelector />
          {user ? (
            <li className="mobile-navigation-item">
              <UserNav />
            </li>
          ) : (
            <>
              {pathname !== SIGNIN && (
                <li className="mobile-navigation-item">
                  <Link
                    className="navigation-menu-link"
                    onClick={onClickLink}
                    to={SIGNIN}
                  >
                    {t('menuSignIn')}
                  </Link>
                </li>
              )}
            </>
          )}
        </ul>
      </div>
      {pathname !== ADMIN_DASHBOARD && (
        <div className="mobile-navigation-sec">
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_DASHBOARD}
          >
            {t('menuAdmin')}
          </Link>
        </div>
      )}
      {pathname === ADMIN_DASHBOARD && (
        <div className="mobile-navigation-sec">
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_PRODUCTS}
          >
            {t('adminProducts')}
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_USERS}
          >
            {t('adminUsers')}
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_COMPANIES}
          >
            {t('adminCompanies')}
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_IMAGES}
          >
            {t('adminImages')}
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_BRANDS}
          >
            {t('adminBrands')}
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_ADS}
          >
            {t('adminAds')}
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_PLANS}
          >
            Pricing
          </Link>
          <Link
            className="navigation-menu-link"
            onClick={onClickLink}
            to={ADMIN_PAYMENTS}
          >
            {t('titlePayments')}
          </Link>
        </div>
      )}
    </nav>
  );
};

MobileAdminNavigation.propTypes = {
  isAuthenticating: PropType.bool.isRequired,
  // eslint-disable-next-line react/require-default-props
  user: PropType.oneOfType([PropType.bool, PropType.object])
};

export default MobileAdminNavigation;
